<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search
            :loading="loading"
            :resourceSettings="resourceSettings"
            @searchResource="searchResource"
            @create="create()"
          />
        </v-col>
        <v-col cols="12">
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center">
                <v-col
                  cols="12"
                  :md="`${resourceSettings.create ? '6' : '9'}`"
                  :class="`${$vuetify.breakpoint.md ? 'pa-0' : 'py-1'}`"
                >
                  <span class="font-weight-bold " style="font-size: 15px;"
                    >{{ resource.total }} {{ i18n.bbtemplates }}</span
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" Paging>
          <Paging
            :resourceSettings="resourceSettings"
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row
                class="pa-0 mb-2 elevation-2 px-2 align-center py-3"
                v-for="(r, i) in resource.data"
                :key="'resource-' + i"
                style="cursor:pointer;"
              >
                <v-col
                  cols="6"
                  md="7"
                  :class="
                    `${arabic ? 'arFont' : 'enFont'} pa-0 font-weight-bold`
                  "
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on"
                        >{{ r.candidate_name }} | {{ r.title }}</span
                      >
                    </template>
                    <div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <span style="font-size:9px;">Title:</span>
                        {{ r.title }}
                      </div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="success"
                        v-if="r.met_requirement"
                        >verified</v-icon
                      >
                      <v-icon v-bind="attrs" v-on="on" color="grey" v-else
                        >verified</v-icon
                      >
                    </template>
                    <span :class="`${arabic ? 'arFont' : 'enFont'} pa-0`">
                      {{ r.met_requirement ? "Tested" : "Not tested yet" }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="6"
                  md="3"
                  :class="
                    `${
                      arabic ? 'arFont' : 'enFont'
                    } pa-0 py-1 adminSwitch text-center`
                  "
                  EDITBUTTON
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        :disabled="r.lock"
                        x-small
                        @click.stop="edit(r)"
                      >
                        <v-icon left size="12">create</v-icon>
                        {{ i18n.editIconTooltip }}
                      </v-btn>
                    </template>
                    <span :class="`${arabic ? 'arFont' : 'enFont'} pa-0`">
                      {{ i18n.editIconTooltip }}
                    </span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="success"
                        :disabled="r.lock"
                        x-small
                        @click.stop="sendTest(r)"
                        class="ml-1"
                      >
                        <v-icon left size="12">send</v-icon>
                        {{ i18n.sendTest }}
                      </v-btn>
                    </template>
                    <span :class="`${arabic ? 'arFont' : 'enFont'} pa-0`">
                      {{ i18n.sendTest }}
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="6"
                  md="1"
                  :class="
                    `${
                      arabic ? 'arFont' : 'enFont'
                    } pa-0 adminSwitch text-center`
                  "
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="error"
                        icon
                        x-small
                        @click.stop="deleteResource(r)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic ? 'arFont' : ''} pa-0`">
                      {{ i18n.delete_template }}
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" NewEditDeleteDialog>
          <v-dialog v-model="dialog" persistent max-width="1000">
            <v-card :loading="loading">
              <v-card-title
                :class="`${arabic ? 'arFont' : 'enFont'} font-weight-bold`"
                style="font-size:22px;"
              >
                <div>
                  {{ i18n.bbtemplates + " | "
                  }}<span class="font-weight-light">{{ i18n.add }}</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form @submit.prevent="postResource" ref="form">
                  <v-row>
                    <v-col cols="12" md="12" class="py-0">
                      <v-text-field
                        :label="i18n.title"
                        :name="i18n.title"
                        outlined
                        :rules="[rules.required]"
                        dense
                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                        v-model="newResource['title']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="9" md="12" class="py-0">
                      <v-text-field
                        :label="i18n.candidate_name"
                        :name="i18n.candidate_name"
                        outlined
                        :rules="[rules.required]"
                        dense
                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                        v-model="newResource['candidate_name']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" md="12" class="py-0">
                      <v-autocomplete
                        :items="genders"
                        :name="i18n.gender"
                        v-model="newResource['gender']"
                        :label="i18n.gender"
                        autocomplete="disabled"
                        :rules="[rules.required]"
                        outlined
                        dense
                        item-text="text"
                        item-value="value"
                        :class="`${arabic ? 'arFont' : 'enFont'}`"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12" class="py-0">
                      <span>{{ i18n.variables }}</span>
                      <div>
                        <v-btn
                          v-for="(variable, v) in variables"
                          :key="v"
                          class="mx-1 my-1"
                          outlined
                          x-small
                          @click="copyVaraible(variable.value)"
                          >{{ variable.text }}</v-btn
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" md="12" class="py-0">
                      <vue-editor
                        ref="editorV"
                        v-model="newResource['content']"
                      ></vue-editor>
                    </v-col>

                    <v-col cols="12" md="12" class="py-0">
                      <v-btn
                        class="mb-3 mt-3"
                        color="primary"
                        size="small"
                        @click.prevent="files.push({ name: '' })"
                        ><v-icon>add</v-icon></v-btn
                      >
                      <div v-for="(attachment, index) in files" :key="index">
                        <v-row>
                          <v-col cols="12" md="11" class="py-0">
                            <v-text-field
                              :placeholder="displayPlaceholder(attachment)"
                              outlined
                              density="compact"
                              compact
                              dense
                              hide-details
                            >
                              <template v-slot:append>
                                <v-btn
                                  :disabled="loading"
                                  @click="
                                    attachment.url
                                      ? open(attachment)
                                      : pickFileFiles(index)
                                  "
                                  :class="`${arabic ? 'arFont' : 'enFont'}`"
                                  color="primary"
                                  small
                                  outlined
                                  >{{
                                    attachment.url ? "open" : i18n["upload"]
                                  }}</v-btn
                                >
                              </template>
                            </v-text-field> </v-col
                          ><v-col cols="12" md="1" class="py-0">
                            <v-btn
                              class="mb-3 text-right"
                              color="red"
                              @click.prevent="
                                removeAttachment(attachment, index)
                              "
                              ><v-icon>delete</v-icon></v-btn
                            ></v-col
                          >
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12" class="py-0">
                      <input
                        type="file"
                        style="display:none;"
                        ref="fileFiles"
                        accept="*"
                        @change="onFilePickedFiles"
                      />
                    </v-col>
                    <v-col cols="12" md="12" class="py-0">
                      <v-spacer></v-spacer>
                      <div class="v-card__actions float-right">
                        <v-btn
                          color="error"
                          text
                          @click.native="closeDialog(newResource)"
                          :class="`${arabic ? 'arFont' : 'enFont'}`"
                          >{{ i18n.cancelBtn }}
                        </v-btn>
                        <v-btn
                          color="success"
                          type="submit"
                          :disabled="!validate(newResource)"
                          text
                          :class="`${arabic ? 'arFont' : 'enFont'}`"
                          >{{ i18n.submitBtn }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <div class="text-center ma-2">
        <v-snackbar v-model="snackbar" color="error">
          {{ error }}

          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Search from "@/components/Search";
import Paging from "@/components/Paging";
import {
  getRandomInt,
  randomString,
  getCDate,
  check,
  sleep,
} from "@/customFunction";
import { format, render, cancel, register } from "timeago.js";
import axios from "axios";
const headers = { Accept: "application/json" };
import LineChart from "@/LineChart.js";
import customAxios from "@/axios";

export default {
  components: { Search, Paging, LineChart, VueEditor },
  data() {
    return {
      snackbarRef: null,
      snackbar: false,
      error: "",
      loading: false,
      dialog: false,
      newDialog: false,
      menu: false,
      menu2: false,
      campaign: {},
      vresource: [],
      genders: [
        {
          text: "Male",
          value: "male",
        },
        {
          text: "Female",
          value: "female",
        },
      ],
      contract_type: [
        {
          text: "Work",
          value: "Work",
        },
        {
          text: "Ausbildung",
          value: "Ausbildung",
        },
      ],
      resource: [],
      search: null,
      rules: {
        required: (value) => !!value || this.i18n["required"],
        email: (value) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          this.i18n["valid_email"],
      },
      resourceKeys: [
        {
          name: "title",
          label: "title",
          type: "text",
          required: true,
        },
        {
          name: "candidate_name",
          label: "candidate_name",
          type: "text",
          required: true,
        },
        {
          name: "gender",
          label: "gender",
          type: "text",
          required: true,
        },
        {
          name: "content",
          label: "content",
          type: "textarea",
          required: true,
        },
      ],
      resourceSettings: {
        resourceName: "bbtemplates",
        search: true,
        create: true,
        pagination: true,
      },

      variables: [
        { text: "Employee Contact", value: "*|EMPLOYEE_CONTACT|*" },
        { text: "Opening line", value: "*|OPENING_LINE|*" },
        { text: "Company name", value: "*|COMPANY_NAME|*" },
        { text: "Candidate name", value: "*|CANDIDATE_NAME|*" },
        { text: "Occupation", value: "*|OCCUPATION|*" },
      ],
      newResource: {},
      editing: false,
      deleting: false,
      states: [],
      templates: [],
      programs: [
        {
          name: "Work",
          value: "work",
        },
        {
          name: "Ausbildung",
          value: "ausbildung",
        },
      ],
      fileindex: null,
      bundeslands: [],
      emails: [],
      sectors: [],
      usersall: [],
      lists: [],
      newCount: 0,
      state_id: [],
      city_id: [],
      occupation_id: [],
      contract_category_type: null,
      number_of_vacancies: null,
      menu1: false,
      menu2: false,
      attachments: [],
      fromDate: null,
      toDate: null,
      page: 1,
      files: [],
      uploadIndex: null,
      imagePreviews: [],
      message: "Upload Image",
    };
  },

  methods: {
    removeAttachment(attachment, index) {
      if (attachment.url) {
        return new Promise(async (res, rej) => {
          this.loading = true;
          await axios.delete(
            "https://arramccogermany.com/api/v1/bb/templates/attachments/" +
              `${attachment.id}`
          );
          this.files.splice(index, 1);
          this.loading = false;
        });
      }
      this.files.splice(index, 1);
    },
    displayPlaceholder(attachment) {
      return attachment.url || attachment.name || "upload Image";
    },
    async copyVaraible(variable) {
      await navigator.clipboard.writeText(variable);
    },
    open(attachment) {
      window.open(attachment.url, "_blank", "noopener");
    },
    pickFileFiles(index) {
      this.$refs.fileFiles.click();
      this.uploadIndex = index;
    },

    onFilePickedFiles(e) {
      const files = Array.from(e.target.files);
      this.files[this.uploadIndex] = files[0];

      this.files = this.files.filter(
        (file) => file.name !== "" && file !== undefined
      );
      this.newResource["attachments"] = this.files;
      console.log(this.files);
    },

    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter((x) => typeof x == "string");
      let a = false;
      v.forEach((x) => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true;
      });
      if (
        itemText &&
        typeof itemText == "string" &&
        itemText.toLowerCase().includes(queryText.toLowerCase())
      )
        a = true;
      return a;
    },

    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter((x) => x.required);
      let fse = this.resourceKeys.filter((x) => x.email);
      let v = true;
      fsr.forEach((x) => {
        if (!newResource[x.name]) {
          v = false;
          if (notify)
            this.$emit(
              "snackbarNotification",
              `${this.i18n[x.name]} ${this.i18n.required}`,
              "error"
            );
        }
      });
      fse.forEach((x) => {
        if (
          !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            newResource[x.name]
          )
        ) {
          v = false;
          if (notify)
            this.$emit(
              "snackbarNotification",
              `${this.i18n[x.name]} ${this.i18n.valid_email}`,
              "error"
            );
        }
      });
      return v;
    },
    getItems(items) {
      return this[items];
    },

    getFormat(d) {
      return format(d);
    },

    buildFilter() {
      let filter = ``;
      if (this.state_id) {
        filter += `&state_id=${[this.state_id].join(",")}`;
      }
      if (this.city_id) {
        filter += `&city_id=${[this.city_id].join(",")}`;
      }
      if (this.occupation_id) {
        filter += `&occupation_id=${[this.occupation_id].join(",")}`;
      }
      if (this.number_of_vacancies) {
        filter += `&number_of_vacancies=${this.number_of_vacancies}`;
      }
      if (this.contract_category_type) {
        filter += `&contract_category_type=${this.contract_category_type}`;
      }
      if (this.fromDate) {
        filter += `&fromDate=${this.fromDate}`;
      }
      if (this.toDate) {
        filter += `&toDate=${this.toDate}`;
      }
      return filter;
    },
    async filterLeads() {
      await this.loadResource();
    },
    create() {
      this.newResource = {};
      this.files = [];
      this.dialog = true;
    },
    edit(r) {
      this.files = r.attachments;
      this.imagePreviews = r.attachments;
      this.newResource = r;
      this.newResource["attachments"] = [];
      this.dialog = true;
    },

    closeDialog(r) {
      if (r.id) {
        r.attachments = this.imagePreviews;
      }
      this.imagePreviews = []; // Clear image previews when closing the dialog
      this.newResource = {}; // Optionally reset newResource if needed
      this.dialog = false;
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        if (!this.search) {
          this.resource = await axios
            .get(
              `https://arramccogermany.com/api/v1/bb/templates`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((x) => x.data);
        } else {
          this.resource = await axios
            .get(
              `https://arramccogermany.com/api/v1/bb/templates?search=${this.search}`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((x) => x.data);
        }
        this.states = this.resource.states;
        this.templates = this.resource.templates;
        this.loading = false;
        res(true);
      });
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.page = n;
        this.resource = await axios
          .get(
            `https://arramccogermany.com/api/v1/bb/templates?page=${n}`
          )
          .then((x) => x.data);
        this.loading = false;
      });
    },
    async searchResource(search) {
      return new Promise(async (res, rej) => {
        this.search = search;
        this.loading = true;
        this.resource = await axios
          .get(
            `https://arramccogermany.com/api/v1/bb/templates?search=${this.search}`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((x) => x.data);
        this.loading = false;
      });
    },

    async deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true;

        await axios.delete(
          `https://arramccogermany.com/api/v1/bb/templates/${r.id}`
        );

        this.dialog = false;
        this.deleting = false;
        this.loading = false;
        await this.loadResource();
        this.newResource = {};
      });
    },

    async postResource() {
      this.loading = true;
      this.newResource["attachments"] = this.files.filter(
        (file) => file.name !== "" && !file.id && file !== undefined
      );
      try {
        if (!this.newResource.id) {
          await axios
            .post(
              `https://arramccogermany.com/api/v1/bb/templates`,
              {
                ...this.newResource,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((x) => x.data);
        } else {
          await axios
            .post(
              `https://arramccogermany.com/api/v1/bb/templates/${this.newResource.id}`,
              {
                ...this.newResource,
              },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((x) => x.data);
        }

        this.dialog = false;
        this.loading = false;
        await this.loadResource();
        this.newResource = {};
      } catch (error) {
        console.error("Error posting resource:", error);
        this.loading = false;
        throw error;
      }
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.$route.path.replace(
        "/",
        "templates"
      );
    },
    async sendTest(template) {
      this.loading = true;
      const response = await customAxios
        .get(
          `https://arramccogermany.com/api/v1/bb/templates/${template.id}/send-test`
        )
        .then((x) => x.data)
        .catch((e) => {
          if (e.response.status == 403) {
            this.snackbar = true;
            this.error = `Error while sending a test email. Reason: ${e.response.data.message}`;
          }
        });

      this.$emit(
        "snackbarNotification",
        `Test email send successfully`,
        "success"
      );

      this.loading = false;
    },
  },
  watch: {},
  computed: {
    api() {
      return this.$store.state.settings.apiBase;
    },
    users() {
      let sa =
        this.$store.state.user && this.$store.state.user.role == "superadmin";
      return this.$store.state.users.filter((x) => {
        if (!sa) {
          return x.superior == this.$store.state.user.level;
        } else return x;
      });
    },
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(
        (x) => x.path == this.$route.path
      );
      let sub = []
        .concat(...this.$store.state.menu.map((x) => x.subs))
        .filter((x) => x)
        .filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      } else {
        return "";
      }
    },
    roles() {
      return this.$store.state.userRoles;
    },
    notifications() {
      return this.$store.state.notifications.sort(
        (a, b) => b.timestamp - a.timestamp
      );
    },
  },
  async created() {
    await this.loadResource();
    await this.setResourceName();
  },
};
</script>

<style>
.adminSwitch .v-input {
  margin-top: 0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom: 0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>
